// Bank accounts belong to the flex account rather than to the instrument, so
// the servicing bank account id has to be passed explicitly to the
// instrument-scoped calls that debit it. Finalize returns it as a string.
function getBankAccountId(finalizeData) {
    const bankAccountId = Number(finalizeData?.bankAccountId);
    return Number.isFinite(bankAccountId) && bankAccountId > 0
        ? bankAccountId
        : undefined;
}
export default getBankAccountId;
